function Header() {
    return (
        <header className="header" id="siteHeader">
            <div className="container header-inner">
            <a className="brand" href="#top" aria-label="Ir para início">
                <img src="/logo-conts.png" className="logo" alt="Conts Contabilidade"/>
            </a>

            <button className="nav-toggle" id="mobileMenuButton" aria-label="Abrir menu" aria-expanded="false" aria-controls="navMenu">
                <span></span><span></span><span></span>
            </button>

            <nav className="nav" id="navMenu" aria-label="Navegação principal">
                <a href="#top" className="nav-link">Início</a>
                <a href="#services" className="nav-link">Especialidades</a>
                <a href="#about" className="nav-link">Sobre</a>
                <a href="#testimonials" className="nav-link">Depoimentos</a>
                <a href="https://wa.me/5519995277000" target="_blank" className="nav-link nav-cta">Fale agora</a>
            </nav>
            </div>
        </header>
    );
}

export default Header;